import { AuthCheck } from 'components'
import React from 'react'

function App() {
  return <AuthCheck />
}

export default App
